import defaultSettings from '@/settings';

const title = defaultSettings.title;

export function getPageTitle(pageTitle) {
    if (pageTitle === 'landing') {
        return 'Smartdrone';
    }
    if (pageTitle) {
        return `${pageTitle} | ${title}`;
    }
    return `${title}`;
}

export function getTicketId(ticket) {
    var returnValue = '';
    var id = String(ticket.id);
    if (ticket.issueType && (ticket.issueType.toUpperCase() === 'P' || ticket.issueType.toUpperCase() === 'PRESUPUESTO')) {
        returnValue += ticket.issueType.charAt(0).toUpperCase();
    }
    while (id.length < 6 - returnValue.length) {
        id = '0' + id;
    }
    returnValue += id;

    return returnValue;
}

// Shared by the Settings "Licencia" tab and the LicenseBanner component so
// both agree on when a license counts as "about to expire" vs "expired".
export function getLicenseStatus(expirationDate, warningDays = 15) {
    var today, expiration, msPerDay, daysUntilExpiration, status;

    if (!expirationDate) {
        return { status: null, daysUntilExpiration: null };
    }

    today = new Date();
    expiration = new Date(expirationDate);

    if (isNaN(expiration.getTime())) {
        return { status: null, daysUntilExpiration: null };
    }

    msPerDay = 1000 * 60 * 60 * 24;

    today.setHours(0, 0, 0, 0);
    expiration.setHours(0, 0, 0, 0);

    daysUntilExpiration = Math.round((expiration.getTime() - today.getTime()) / msPerDay);
    status = 'active';

    if (daysUntilExpiration < 0) {
        status = 'expired';
    } else if (daysUntilExpiration <= warningDays) {
        status = 'warning';
    }

    return { status: status, daysUntilExpiration: daysUntilExpiration };
}

export function formatDate(date, withTime) {
    var dateArray, retVal = '';
    if (date) {
        dateArray = date.split('T')[0].split('-');
        retVal = dateArray[2] + '/' + dateArray[1] + '/' + dateArray[0];

        if (withTime) {
            retVal += ' ' + date.split('T')[1].substr(0, 8);
        }
    }
    return retVal;
}
